import { render, staticRenderFns } from "./MarketTitle.vue?vue&type=template&id=0c9d0aaa&scoped=true&"
import script from "./MarketTitle.vue?vue&type=script&lang=js&"
export * from "./MarketTitle.vue?vue&type=script&lang=js&"
import style0 from "./MarketTitle.vue?vue&type=style&index=0&id=0c9d0aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d0aaa",
  null
  
)

export default component.exports